import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';

const Details = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlogDetails = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('slug', slug);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.blogDetails}`,
          data: formData,
        });
        if (response.data.status === 'ok') {
          setBlog(response.data.blog);
        }
      } catch (err) {
        console.error('Failed to load blog', err);
      }
    };

    fetchBlogDetails();
  }, [slug]);

  if (!blog) return <p>Loading blog...</p>;

  return (
    <div>
      <Helmet>
        <title>{blog.title}</title>
        <meta name="description" content={blog.content.slice(0, 150)} />
      </Helmet>

      <div className="row">
        <div className="col-md-8">
          <div className="blog-details-section">
            <div className="blog-box">
              <div className="blog" style={{ width: '100%', margin: 'auto', boxShadow: 'none', border: '1px solid #ccc' }}>
                <div className="blog-detail-image">
                  <img
                    src={blog.image || 'https://via.placeholder.com/400x200?text=No+Image'}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="date">
                    {new Date(blog.created_at).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </div>
                </div>
                <div className="blog-detail-content">
                  <h2>{blog.title}</h2>
                  <div dangerouslySetInnerHTML={{ __html: blog.content }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
            <div className="rc-cards">
                <div className="rc-card mb-4">
                    <img src="https://images.contentstack.io/v3/assets/bltb428ce5d46f8efd8/blt3ac2f5322ad65d29/609c45e57f38be03500fe7f1/PJM013418Q426-Seasonal_Africa-Day6-2-Host_ChiChi-01261_169crop.jpg" alt="" className="rc-card-img" />
                    <p className="rc-card-txt">Exploring your new hosting tools</p>
                </div>
                <div className="rc-card">
                    <img src="https://images.contentstack.io/v3/assets/bltb428ce5d46f8efd8/blt3ac2f5322ad65d29/609c45e57f38be03500fe7f1/PJM013418Q426-Seasonal_Africa-Day6-2-Host_ChiChi-01261_169crop.jpg" alt="" className="rc-card-img" />
                    <p className="rc-card-txt">Helping your listing stand out</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
